import { BetHistoryService } from './service/BetHistoryService'
import { betHistoryApi, mockBetHistoryApi } from './api/betHistoryApi'

/**
 * This instance is initialized with the API client for bet history.
 * @type {BetHistoryService}
*/
export const betHistoryService: BetHistoryService = new BetHistoryService(betHistoryApi)

const serviceV2Api
  = import.meta.env.MODE === 'development' ? mockBetHistoryApi : betHistoryApi

/**
 * This instance dynamically uses either a mock API client or the real API client for bet history,
 * based on the current environment mode.
 * @type {BetHistoryService}
 */
export const betHistoryServiceV2: BetHistoryService = new BetHistoryService(serviceV2Api)
